<template>
  <div class="content login">
    <div class="logo_img animated tada" @click="test">
      <!-- <img src="./img/切图/logo/_logo.png" alt="" style="width:auto;height:100%;"/> -->

      <!-- <img src="./img/切图/logo/logo.png" alt="" style="height:100%;width:auto;"/> -->
      <div class="logo_text" style="padding-left:1%;">
        <p>金山区分区计量管理系统</p>
        <!-- <p>嘉定黄渡自来水有限公司</p> -->
      </div>
      
    </div>
    <div class="rightbox">
      <template v-for="(item_y, y) in box_list[0].length">
        <template v-for="(item_x, x) in box_list.length">
          <div
            :key="x + '_' + y"
            :pos="x + '_' + y"
            class="animated"
            :class="{
              rotateIn: box_list[x][y].item_type == 2,
              zoomInRight: box_list[x][y].item_type != 2,
              delay_0: box_list[x][y].item_type == 2,
              delay_1: box_list[x][y].item_type != 2,
            }"
          >
            <div
              v-if="box_list[x][y] != 0"
              class="empty menu_node"
              :style="{
                backgroundColor: box_list[x][y].bg_color
                  ? box_list[x][y].bg_color
                  : '',
                backgroundImage:
                  box_list[x][y].bg_1 == ''
                    ? ''
                    : 'url(' + require(`${box_list[x][y].bg_1}`) + ')',
                opacity: box_list[x][y].opacity ? box_list[x][y].opacity : 1,
              }"
              :class="{
                nopower_box:
                  !box_list[x][y].power && //权限false
                  box_list[x][y] != 0 && //有节点
                  box_list[x][y].item_type != 2, //非图标
                menu_node_hover: box_list[x][y].item_type != 2, //2是图标
                menu_img: box_list[x][y].item_type == 2, //图标

                quit_box: box_list[x][y].webName == quit_name,
              }"
              @click="nodeClick(box_list[x][y])"
            >
              <p v-if="box_list[x][y].show_text">
                {{ box_list[x][y].webName }}
              </p>
            </div>
            <div v-else></div>
          </div>
        </template>
      </template>
    </div>
    <div>
      <!--弹框-->
      <a-modal v-model="dialogVisible" title="提示" :footer="null">
        <div>您没有访问权限！</div>
        <div style="width: 100%; text-align: right; margin: 20px 0 5px 0">
          <a-button
            type="primary"
            @click="
              () => {
                dialogVisible = false;
              }
            "
            >确认</a-button
          >
        </div>
      </a-modal>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      quit_name: "退出",
      timer: "",
      webtoken_list: [],
      menu_list: [],
      box_list: [],
      userRights: [],
      dialogVisible: false,
      quiturl: "/unilogin",
    };
  },
  mounted: function () {
    this.timer = setInterval(this.ping, manage.ping_time);
  },
  methods: {
    ping() {
      var that = this;
      console.log(manage);
      console.log(that.webtoken_list);
      manage.system.forEach((element) => {
        //不需要ping
        if (!element.need_ping) {
          return;
        }
        var system = that.webtoken_list.find((n) => {
          return n.id == element.id;
        });

        var path = element.defalut_ping_url;
        var headers = {
          token: system.token,
        };
        var params = {
          appIdentity: element.default_appIdentity,
        };
        //ping
        this.public_function.h_Ajax(
          path,
          "get",
          params,
          headers,
          1,
          function (data) {},
          function (err) {}
        );
        //检查token
        if (!element.validate_token) {
          return;
        }
        path = element.validate_token + system.token;
        params = {};
        this.public_function.h_Ajax(
          path,
          "get",
          params,
          headers,
          2,
          function (data) {
            if (!data) {
              console.log("!!!!!!!!!!!!!!!!!!!!!!", element.validate_token);
              //  that.logoff();
            }
          },
          function (err) {
            that.logoff();
          }
        );
      });
    },
    logoff() {
      this.$store.commit("delToken");
      this.$router.push({ path: this.quiturl });
    },
    get_data_list() {
      var that = this;
      this.get_menu_init();
      for (var i = 0; i < manage.item.length; i++) {
        that.get_data(i);
      }
    },
    get_data(i) {
      var that = this;
      //console.log(manage.item[i], i);
      var item_type = manage.item[i].item_type;
      //菜单类型判断
      if (item_type == 1 || manage.item[i].system_id == -1) {
        //越过权限
        console.log(i, manage.item[i].webName + "_特殊权限");
        that.openpower(i);
        return;
      }
      //純图标
      if (item_type == 2) {
        // console.log(
        //   i,
        //   (manage.item[i].webName == null ? "未命名" : manage.item[i].webName) +
        //     "_图标展示"
        // );
        that.openpower(i);
        return;
      }
      //得到带token平台
      var system = that.webtoken_list.find((n) => {
        return n.id == manage.item[i].system;
      });

      if (system.token == "") {
        //菜单token未找到
        return;
      }
      var headers = {
        "Content-Type": "application/json;charset=UTF-8",
        token: system.token,
      };
      let path = system.url + system.menu + manage.item[i].code;

      this.public_function.h_Ajax(
        path,
        "get",
        {},
        headers,
        1,
        function (data) {
          if (data == null || data == [] || data.length == 0) {
            //当前菜单没权限
            return;
          } else {
            // console.log(data, i);
            that.openpower(i);
          }
        },
        function (data) {
          // 单次异常
          return;
        }
      );
    },
    get_menu() {
      var that = this;
      var new_menu = [];
      for (var i = 0; i < this.menu_list.length; i++) {
        var dataInfo = this.menu_list[i];
        //无权限码
        if (!dataInfo.authCode || dataInfo.authCode == undefined) continue;
        for (var z = 0; z < manage.item.length; z++) {
          var element = manage.item[z];
          if (element.code == dataInfo.authCode) {
            manage.item[z].power = dataInfo.authorized;
          }
        }
      }
      this.get_menu_init();
    },
    openpower(i) {
      var that = this;
      //普通权限的 判断token存在  //特殊的默认不判断
      if (manage.item[i].item_type == 0 && manage.item[i].system != -1) {
        var system = that.webtoken_list.find((n) => {
          return n.id == manage.item[i].system;
        });
        if (system == null) {
          console.log(i, "找不到所属平台");
        }
        if (system.token == "") {
          console.log(manage.item[i].webName + "无法开启权限，没有token");
          return;
        }
      }

      var x = manage.item[i].menu_position[0];
      var y = manage.item[i].menu_position[1];
      that.box_list[x][y].power = true;
      that.$forceUpdate();
    },
    test() {
      console.log(manage.ping_time);
      //this.ping();
    },
    //画出布局
    get_menu_init() {
      var max_x = 5;
      var max_y = 4;
      for (var x = 0; x < max_x; x++) {
        var box_list2 = [];
        for (var y = 0; y < max_y; y++) {
          box_list2.push(0);
        }
        this.box_list.push(box_list2);
      }
      manage.item.forEach((n) => {
        var x = n.menu_position[0];
        var y = n.menu_position[1];
        if (x < max_x && y < max_y) {
          var js_n = JSON.stringify(n);
          this.box_list[x][y] = JSON.parse(js_n);
        }
      });
      console.log(this.box_list, "___");
      this.$forceUpdate();
    },
    //点击菜单
    nodeClick(node) {
      var that = this;
      //得到所属平台
      var system = that.webtoken_list.find((n) => {
        return n.id == node.system;
      });
      //不可点
      if (node == 0 || node.item_type == 2) {
        return;
      }
      //无权限
      if (!node.power) {
        that.dialogVisible = true;
        return;
      }
      if (node.webName == this.quit_name) {
        that.logoff();
        return;
      }
      //没有token 的普通按钮  特殊默认不判断
      if (system.token == "" && node.item_type == 0) {
        alert("该系统未成功获取token");
        return;
      }
      //点击逻辑
      const url = node.webUrl;
      var url_link = url.indexOf("?") > 0 ? "&" : "?";
      var open_url = `${node.webUrl}${url_link}${node.queryName}=${system.token}`;
      console.log(open_url, "跳转");
      window.open(open_url, "_blank");
      return;
    },
  },
  created: function () {
    console.log("create");
    var that = this;
    let TOKEN = that.$store.getters.getToken;
    if (!TOKEN) {
      alert("token失效或登录失败！");
      that.$router.push({ path: "/unilogin" });
      return;
    }

    this.webtoken_list = JSON.parse(TOKEN);

    this.get_data_list();
    this.ping();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
};
</script>
<style lang="scss" scoped>
body {
  margin: 0;
  overflow: hidden;
}
.content {
  background-image: url("img/login/dlybg05.png");
  background-repeat: no-repeat;
  background-size: contain;
  overflow: hidden;
  height: 100%;
  width: 100%;
}

/*登录页 样式开始*/
.login .body {
  float: left;
  width: 33vw;
  height: 330px;

  background-image: url(img/login/login.png);
  background-size: cover;
  position: fixed;
  top: calc(50% - 180px);
  left: 50%;
  padding: 30px;
}
.logo_img {
  //  background-image: url("../../assets/logo.png");
  //  background-repeat: no-repeat;
  //  background-size: 100% 100%;
  width: 45%;
  height: 10vw;
  position: fixed;
  top: calc(50% - 5vw);
  left: 8%;
  background-size: 100%;
  display: flex;
  > img {
    width: 25vw;
    height: calc(25vw / 421 * 159);
    transform: scale(0.8);
  }
  > .logo_text {
    width: calc(100% - 10vw);
    padding-left: 10%;
    display: flex;
    flex-direction: column;
    justify-items: center;
    justify-content: center;
    line-height: 4vw;
    > p:nth-child(1) {
      font-size: 2.2vw;
      margin-bottom: 0em;
      font-weight: bold;
    }
    > p:nth-child(2) {
      font-size: 2vw;
      color: #838f99;
      margin-bottom: 0em;
    }
  }
}
.rightbox {
  left: 53%;
  top: calc(50% - 16vw - 2px);
  position: fixed;
  width: calc(40vw + 10px);
  height: calc(32vw + 8px);
  display: grid;
  grid-template-columns: 8vw 8vw 8vw 8vw 8vw;
  grid-template-rows: 8vw 8vw 8vw 8vw;
}
.empty {
  width: 8vw;
  height: 8vw;
  margin: 1px;
  float: left;
  background-repeat: no-repeat;
  background-size: 100%;
  cursor: pointer;
}
.quit_box {
  width: 4vw;
  height: 4vw;
  margin-top: 4vw;
}
.gray {
  background: #e9f3fc;
}
.clear {
  clear: both;
}

.nopower_box:after {
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;
  background: rgba(0, 0, 0, 0.4);
}
/*加亮*/
.menu_node:hover:after {
  // position: absolute;
  // content: "";
  // left: 0;
  // right: 0;
  // top: 0;
  // bottom: 0;
  // z-index: 10;
  // background: rgba(255, 255, 255, 0.4);
}
/*纯图标 */
.menu_img {
}
//移入样式 变大
.menu_node {
  transform: scale(0.97) !important;
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  position: relative;
  > p {
    position: absolute;
    text-align: center;
    top: 75%;
    width: 100%;
    color: #fff;
  }
}
//移入变大
// .menu_node_hover:hover {
//   transform: scale(1.05) !important;
//   p {
//     animation: sport 0.3s;
//   }
// }
//移入加底图
.menu_node_hover:hover::after {
  position: absolute;
  content: "";
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 10;

  background-image: url("./img/切图/xz.png");

  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
}

@keyframes sport {
  0% {
    bottom: 0%;
    opacity: 1;
  }
  100% {
    bottom: 8%;
    opacity: 1;
  }
}

.delay_0 {
  -webkit-animation-delay: 0s;
  animation-delay: 0s;
}
.delay_1 {
  -webkit-animation-delay: 0.25s;
  animation-delay: 0.25s;
}
.delay_2 {
  -webkit-animation-delay: 1s;
  animation-delay: 1s;
}
.delay_3 {
  -webkit-animation-delay: 1.5s;
  animation-delay: 1.5s;
}
.delay_4 {
  -webkit-animation-delay: 2s;
  animation-delay: 2s;
}
.delay_5 {
  -webkit-animation-delay: 2.5s;
  animation-delay: 2.5s;
}
</style>
